"use client";

import { useState } from "react";

// FAQ accordion for the Bathe booking page — content mirrors the "Our Hot Pools
// facilities" section on aluume.com/bathe-hot-pools.
const FAQS: { q: string; a: string }[] = [
  {
    q: "Are towels provided?",
    a: "Towel hire is included with every booking. Simply leave your towel in the pool area after your session and we'll take care of the rest.",
  },
  {
    q: "Can I bring drinks, and what's provided?",
    a: "Staying hydrated keeps the heat comfortable, so bring a refillable bottle — on-site refill stations are available. Every booking also includes a complimentary arrival refreshment: Aspiring Water (glacial-fed from Mt Aspiring National Park), naturally flavoured sparkling water, or a Juicie ice block. Bathe is an alcohol-free space, so we kindly ask that you don't bring or consume alcohol during your visit.",
  },
  {
    q: "Where do I get changed?",
    a: "Communal pool guests share a changing space — a quick rinse before you soak is appreciated. Each private pool has its own dedicated changing room with a shower.",
  },
  {
    q: "Where can I keep my belongings?",
    a: "In the communal pool, private lockers are available. In the private pools, a Bathe tote is provided for your items, with designated hooks.",
  },
  {
    q: "Where are you, and where do I park?",
    a: "We're at 34 Brecon Street, Queenstown. For the easiest access, we recommend Skyline's multi-storey carpark at the top of Brecon Street.",
  },
  {
    q: "What happens if the weather's bad?",
    a: "Rain, wind, or shine — our pools are perfectly sheltered and kept at just the right temperature.",
  },
];

export function BatheFaqs() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="mx-auto w-full max-w-[760px] px-6 pb-16 pt-2 md:pb-20 md:pt-4">
      <p className="eyebrow mb-3 text-ink-mute">Good to know</p>
      <h3 className="mb-8">Your visit, answered</h3>
      <div className="flex flex-col">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="border-b border-ink/10">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
              >
                <span className="body text-ink" style={{ fontWeight: 400 }}>{f.q}</span>
                <span
                  className="shrink-0 text-ink-mute transition-transform duration-200"
                  style={{ transform: isOpen ? "rotate(45deg)" : "none", fontSize: 22, lineHeight: 1 }}
                  aria-hidden
                >
                  +
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{ maxHeight: isOpen ? 320 : 0, opacity: isOpen ? 1 : 0 }}
              >
                <p className="body pb-5 pr-8 text-ink-soft">{f.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
